<template>
  <b-modal ref="modalDemandeDate" size="s"
    :title="titreModal" 
    :ok-title="titreBoutonOk"
    :ok-only="true"
    no-close-on-backdrop
    @ok="choisirDate()"
    @show="initialiserModale()"
  >
    <div style="display: inline">
        <div class="container-fluid card card-body">
          <!--<h4 class="push-bottom-2rem">Informations produit</h4>-->
          <div class="row">
            <div class="col-12 form-group">
              <label>{{ titreDate }}</label>
              <v-date-picker class="date-picker" :min-date="dateMinimum" :max-date="dateMaximum" :columns="1" :step="1" v-model="dateChoisie" :popover="{ visibility: 'click' }">
                  <template v-slot="{ inputValue, inputEvents }">
                  <input :value="inputValue" v-on="inputEvents"/>
                  </template>
              </v-date-picker>
            </div>
          </div>
        </div>
    </div>
  </b-modal>
</template>

<script>
import { showAlerts } from "@/mixins/alerts"
import { connecteData } from "@/mixins/connecteData"
import { formatageDate, formatHumanDateAvecSlashes } from '@/mixins/dateFormats'

export default {
  name: "ModalDemandeDate",
  props: [ 'titreModal', 'titreDate', 'dateMinimum', 'dateMaximum', 'dateSelectionnee' ],
  mixins: [
    showAlerts,
    connecteData,
    formatageDate,
    formatHumanDateAvecSlashes
  ],
  components: {

  },
  data() {
    return {
      key: 1,
      dateChoisie: {},
      titreBoutonOk: ""
    }
  },
  computed: {
    
  },
  methods: {
    initialiserModale() {
      this.dateChoisie = this.dateSelectionnee
      this.titreBoutonOk = "OK"
    },

    choisirDate() {
      this.$emit("dateChoisie", this.dateChoisie)
    },
    show() {
      this.$refs.modalDemandeDate.show()
    },
    hide() {
      this.$refs.modalDemandeDate.hide()
    },
  },
  async mounted() {

  }
}
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
